import { useState } from "react";
import AdminModal from "../../../core/admin/adminModal";
import { IFAQ } from "./adminFaqs";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../../firebase";
import AdminToast from "../../../core/admin/adminToast";
import AdminButton from "../../../core/admin/adminButton";
import AdminBadge from "../../../core/admin/adminBadge";
import AdminField, { AdminTextarea } from "../../../core/admin/adminField";
import AdminTextInput from "../../../core/admin/adminTextInput";
import { PencilIcon } from "../../../../img/svg/adminIcons";

export default function EditFAQModal({ close, faq, finish }: { close: () => void, faq: IFAQ, finish: (faq: IFAQ) => void }) {

    const [question, setQuestion] = useState(faq.question);
    const [answer, setAnswer] = useState(faq.answer);
    const [edit, setEdit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [badToast, setBadToast] = useState(false);

    const updateFaq = async () => {
        try {
            if (!question || !answer) {
                return null;
            }
            setLoading(true);
            const docRef = doc(db, "faqs", faq.id);
            await updateDoc(docRef, {
                question,
                answer
            });
            finish({ ...faq, question, answer });
        } catch (error) {
            console.log(error);
            setBadToast(true);
        } finally {
            setLoading(false);
        }
    }

    const handleQuestion = (e: string) => {
        if (e.length < 152) {
            setQuestion(e);
        }
    }

    const handleAnswer = (e: string) => {
        if (e.length < 500) {
            setAnswer(e);
        }
    }

    return (
        <AdminModal
            close={close}
            title="FAQ"
            subtitle={faq.display ? <AdminBadge tone="success" dot>Visível no site</AdminBadge> : <AdminBadge dot>Oculta</AdminBadge>}
            footer={
                edit ?
                    <>
                        <AdminButton variant="secondary" disabled={loading} onClick={() => setEdit(false)}>Cancelar</AdminButton>
                        <AdminButton loading={loading} onClick={updateFaq} disabled={answer === faq.answer && question === faq.question} className="sm:min-w-[120px]">Salvar</AdminButton>
                    </>
                    :
                    <AdminButton variant="secondary" icon={<PencilIcon width="14px" />} onClick={() => setEdit(true)}>Editar</AdminButton>
            }
        >
            <div className="flex flex-col gap-4">
                <AdminField label="Pergunta" htmlFor="edit-faq-question" counter={edit ? { current: question.length, max: 151 } : undefined}>
                    <AdminTextInput id="edit-faq-question" disabled={!edit || loading} value={question} onChange={e => handleQuestion(e.target.value)} />
                </AdminField>
                <AdminField label="Resposta" htmlFor="edit-faq-answer" counter={edit ? { current: answer.length, max: 499 } : undefined}>
                    <AdminTextarea id="edit-faq-answer" rows={6} disabled={!edit || loading} value={answer} onChange={e => handleAnswer(e.target.value)} />
                </AdminField>
            </div>
            <AdminToast toast={badToast} setToast={setBadToast} tone="danger" message="Erro!" />
        </AdminModal>
    )
}
